import { render, staticRenderFns } from "./WidgetLink.vue?vue&type=template&id=4abc9804&scoped=true&"
import script from "./WidgetLink.vue?vue&type=script&lang=js&"
export * from "./WidgetLink.vue?vue&type=script&lang=js&"
import style0 from "./WidgetLink.vue?vue&type=style&index=0&id=4abc9804&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abc9804",
  null
  
)

export default component.exports